<template>
    <v-select
        id="customer"
        class="search-customer-form"
        :placeholder="placeholder"
        :options="customers"
        @input="onSearchInput"
        label="name">
        <div slot="no-options">Aucun résultat ne correspond à votre recherche</div>
    </v-select>
</template>

<script>
    import vSelect from 'vue-select';

    export default {
        name: "SearchCustomerForm",

        components: {
            vSelect,
        },

        props: {
            customers: {
                type: Array,
                required: true,
            },
            placeholder: {
                type: String,
                required: true,
            },
            useQueryParam: {
                type: Boolean,
                required: false,
                default: false,
            },
            action: {
                type: String,
                required: true,
            }
        },


        methods: {
            onSearchInput(e) {
                if (e.id != null && e.id)  {
                    if (this.useQueryParam) {
                        window.location = this.action + '?client=' + e.id;
                    } else {
                        window.location = this.action + '/' + e.id;
                    }
                }
            },
        },
    }
</script>
